import { createReducer } from '@reduxjs/toolkit';
import { PlayerState } from '../types/player';
import { logout } from '../types';
import {
  setPlaying,
  setCurrentDuration,
  seekToTime,
  setActiveIssueId,
  resetPlayer,
} from '../actions/player';

const initialState: PlayerState = {
  playing: false,
  currentDuration: 0,
  seekTime: null,
  activeIssueId: null,
};

export const playerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setPlaying, (state, action) => {
      state.playing = action.payload;
    })
    .addCase(setCurrentDuration, (state, action) => {
      state.currentDuration = action.payload;
    })
    .addCase(seekToTime, (state, action) => {
      state.seekTime = action.payload;
    })
    .addCase(setActiveIssueId, (state, action) => {
      state.activeIssueId = action.payload;
    })
    .addCase(resetPlayer, (state) => {
      state.playing = false;
      state.currentDuration = 0;
      state.seekTime = null;
      state.activeIssueId = null;
    })
    .addCase(logout, (state) => {
      state.playing = false;
      state.currentDuration = 0;
      state.seekTime = null;
      state.activeIssueId = null;
    });
});
